import { getAuthHeaders } from '../../../actions/authActions';
import tempMeeApi from '../../../apis/tempMee';

/**
 * Shortlist a candidate
 *
 * @param {import('../types/ShortlistCandidate.parameters').IShortlistCandidatePayload} payload - Request payload
 * @returns {Promise<void>} No content response
 */
export const shortlistCandidate = async ({ candidateId }) => {
  const headers = await getAuthHeaders();
  await tempMeeApi.post(`/recruitment-service/admin/candidates/${candidateId}/shortlist`, null, {
    headers,
  });
};
